export namespace SystemUsersConstants {
  export const SystemUsersForm = 'SystemUserForm';
  export const SystemUsersFormFirstTime = 'SystemUserFormFirstTime';
}
